import { css } from "styled-components";

export const truncate = `
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

/**
 * Creates a table layout using css grid.
 * Also creates a selector for each column.
 * Parse an object where each key is used as a columnId
 * and each value represents the corresponding column width
 * @example
 * GridTable({
 * 	col1: `50px`,
 * 	col2: `min-content`,
 * 	col3: `auto`
 * })
 * @param {Object} columns
 * @return {string} Returns the css styles as a string literal
 **/
export const GridTable = (columns) => {
    const baseStyles = `
		display: grid;
        align-items: center;
	`;

    const gridTemplateColumns = Object.entries(columns).reduce(
        (style, [key, value], pos, arr) => {
            const prevKey = pos > 0 ? arr[pos - 1][0] : ``;
            switch (pos) {
                case 0:
                    if (arr.length === 1) {
                        return `grid-template-columns: [${key}-start] ${value} [${key}-end]`;
                    }
                    return `grid-template-columns: [${key}-start] ${value}`;
                case arr.length - 1:
                    return `${style}
					[${prevKey}-end ${key}-start] ${value}
					[${key}-end]`;
                default:
                    return `${style}
					[${prevKey}-end ${key}-start] ${value}`;
            }
        },
        ``
    );

    const colStyles = Object.keys(columns).reduce((style, key) => {
        return `${style}
			.col-${key} {
				grid-column-start: ${key}-start;
				grid-column-end: ${key}-end;
			}
		`;
    }, ``);

    const styles = `${baseStyles} ${gridTemplateColumns}; ${colStyles}`;
    return css`
        ${styles}
    `;
};
